export default "__VITE_ASSET__HgjIOE0m__"